import { render, staticRenderFns } from "./tasks-special-filter.vue?vue&type=template&id=2be556d8&scoped=true"
import script from "./tasks-special-filter.vue?vue&type=script&lang=js"
export * from "./tasks-special-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be556d8",
  null
  
)

export default component.exports